import "./index.css";
import HotelBookingDashboard from "./HotelBookingDashboard";

export function App() {
  return <HotelBookingDashboard />;
}

export default App;
